import { AxiosError } from 'axios';
import { Modal } from 'react-bootstrap';
import api from '../../../services/api';
import { useEffect, useState } from 'react';
import Spinner from '../../../rxlib/components/spinner';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApiError, FormExclusao } from '../../../services/tipos';
import { Exclusao } from '../../../rxlib/components/layout/exclusao';

interface DocumentoAcessoExclusaoProps {
    show: boolean;
    onHide: () => void;
    idDocumentoAcesso: string;
    onExcluir: (valor: boolean) => void;
    tratarErro: (error: AxiosError<ApiError>, mensagem: string) => void;
}

function DocumentoAcessoExclusao(props: DocumentoAcessoExclusaoProps) {
    const [documento, setDocumento] = useState<string>('');
    const [carregando, setCarregando] = useState<boolean>(false);
    const [carregandoDocumentoAcesso, setCarregandoDocumentoAcesso] = useState<boolean>(false);

    const { handleSubmit } = useForm<FormExclusao>();

    useEffect(() => {
        if (props.show) {
            setCarregandoDocumentoAcesso(true);
            api.get(`/DocumentoAcessoUsuario/${props.idDocumentoAcesso}`)
                .then(response => {
                    setDocumento(response.data.documento);
                    setCarregandoDocumentoAcesso(false);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregandoDocumentoAcesso(false);
                    props.tratarErro(error, 'Não foi possível realizar a consulta: ');
                });
        }
    }, [props]);

    const onSubmit: SubmitHandler<FormExclusao> = data => {
        setCarregando(true);
        api.delete(`/DocumentoAcessoUsuario/${props.idDocumentoAcesso}`, data)
            .then(response => {
                informarSucesso();
            }).catch((error: AxiosError<ApiError>) => {
                setCarregando(false);
                props.tratarErro(error, 'Não foi possível excluir o documento para acesso do usuário: ');
            });
    }

    function informarSucesso() {
        props.onHide();
        props.onExcluir(true);
        setCarregando(false);
    }

    return (
        <Modal show={props.show} onHide={props.onHide} dialogClassName='rxlib-modal-exclusao' centered>
            <Modal.Body className='rxlib-modal-exclusao-body'>
                {
                    carregandoDocumentoAcesso
                        ? <Spinner
                            classStyle='rxlib-spinner' />
                        : <Exclusao
                            carregando={carregando}
                            onCancelar={props.onHide}
                            onSubmit={handleSubmit(onSubmit)}
                            titulo={`Deseja realmente excluir o documento para acesso ${documento}?`} />
                }
            </Modal.Body>
        </Modal>
    );
}

export default DocumentoAcessoExclusao;